export const sortQVariants = (variantA, variantB) => variantA.variant_id.localeCompare(variantB.variant_id);
